<script lang="ts" setup>
import {
  TirPmButton,
  TirPmModal,
  TirPmButtonVariantEnum,
  TirPmButtonSizeEnum,
} from "tir-components";
import { computed, ref } from "vue";
import { TreeItemType } from "../enums";

/**Тип удаляемого элемента */
const type = ref();

/**Описание ошибки */
const errorMessage = computed(() => {
  switch (type.value) {
    case TreeItemType.Queue:
      return "Очередь содержит задачи.";
    case TreeItemType.Group:
      return "Для удаления папки необходимо очистить её содержимое.";
    case TreeItemType.Namespace:
      return "Имеются очереди. Удалить возможно только пустую от очередей рабочую область.";
  }
});

/**Открытие модального окна по типу удаляемого элемента */
const open = (_type: TreeItemType) => {
  type.value = _type;
};
/**Закрыть окно */
const close = () => {
  type.value = undefined;
};

/**Код для использования по ref */
defineExpose({ open });
</script>
<template>
  <TirPmModal
    is-close-overlay
    classes="remove-stopper-modal"
    :is-with-back="false"
    :is-visible="!!type"
    title="Удаление невозможно"
    @close="close"
  >
    <template #content>
      <div v-text="errorMessage" class="remove-stopper-modal_content" />
    </template>
    <template #footer>
      <TirPmButton
        :variant="TirPmButtonVariantEnum.PrimaryState"
        :size="TirPmButtonSizeEnum.Regular"
        @click="close"
      >
        Понятно
      </TirPmButton>
    </template>
  </TirPmModal>
</template>
<style lang="scss">
.remove-stopper-modal {
  &_content {
    color: var(--text-secondary, #686c73);
  }
}
</style>
